import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { Link } from "@quintype/components";
import Icon from "../../atoms/icon";

import styles from "./styles.m.css";

const renderBreakingNewsMarquee = breakingNews => {
  const items = breakingNews.map(story => {
    const linkedStorySlug = get(story, ["metadata", "linked-story-slug"]);
    if (linkedStorySlug) {
      return (
        <Link
          aria-label={`${"Read full story: "} ${story.headline}`}
          key={story.id}
          className={styles["item"]}
          href={`/${linkedStorySlug}`}
        >
          {story.headline}
        </Link>
      );
    }

    return (
      <div key={story.id} className={styles["item"]}>
        {story.headline}
      </div>
    );
  });

  let className = items.length <= 3 ? `${styles["no-animation-desktop"]} ` : "";
  className += items.length <= 1 ? styles["no-animation-mobile"] : "";

  return (
    <div className={`${styles["marquee-wrapper"]} ${className}`} style={{ "--items": breakingNews.length }}>
      <div className={styles["marquee-container"]}>{items}</div>
      <div className={`${styles["marquee-container"]} ${styles.clone}`}>{items}</div>
    </div>
  );
};

const BreakingNews = ({ className = "", breakingNews = [] }) => {
  if (!breakingNews.length) {
    return null;
  }

  return (
    <div className={`${styles["base"]} ${className} ${styles["container"]} container`}>
      <Icon type={"breaking-news"} className={styles["icon"]} />
      {renderBreakingNewsMarquee(breakingNews)}
    </div>
  );
};

BreakingNews.propTypes = {
  breakingNews: PropTypes.arrayOf(
    PropTypes.shape({
      headline: PropTypes.string,
      id: PropTypes.string,
      metadata: PropTypes.shape({
        "linked-story-slug": PropTypes.string
      })
    })
  ),
  className: PropTypes.string
};

export default BreakingNews;
